import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import "../../css/profile.css";
import { axiosAuth } from "../../utils/axiosInstance";
import Cookies from "js-cookie";

const Profile = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = Cookies.get("USER_TOKEN");
        const response = await axiosAuth.get("get-user-details");
        if (response.status === 200 && response.data?.user) {
          const user = response.data.user;

          // Use reset to populate form with user data
          reset({
            name: user.name || "",
            email: user.email || "",
            contact: user.contact || user.phone || "",
            address: user.address || "",
          });
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [reset]);

  const onSubmit = async (data) => {
    const payLoad = {
      name: data.name,
      email: data.email,
      contact: data.contact,
      address: data.address,
    };

    try {
      const response = await axiosAuth.post("profileUpdate", payLoad);
      if (response.statusText === "OK") {
        reset(data);
        alert("Profile updated successfully.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  if (loading) {
    return <div className="text-center my-5">Loading Profile...</div>;
  }

  return (
    <section className="edit-profile-usr">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h4 className="fw-bold">Edit Profile</h4>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row mt-lg-3">
                <div className="col-lg-6">
                  <div className="form-row">
                    <label htmlFor="name" className="form-label">
                      Full Name
                    </label>
                    <input
                      type="text"
                      className="form-input"
                      placeholder="Enter First Name"
                      {...register("name", { required: true })}
                    />
                    {errors.name && (
                      <p className="error-message">First name is required</p>
                    )}
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-row">
                    <label htmlFor="contact" className="form-label">
                      Contact No
                    </label>
                    <input
                      type="text"
                      className="form-input"
                      placeholder="9548316146"
                      {...register("contact", { required: true })}
                    />
                    {errors.contact && (
                      <p className="error-message">
                        Contact number is required
                      </p>
                    )}
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-row">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-input"
                      placeholder="Enter email"
                      {...register("email", { required: true })}
                    />
                    {errors.email && (
                      <p className="error-message">Email is required</p>
                    )}
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-row">
                    <label htmlFor="address" className="form-label">
                      Address
                    </label>
                    <input
                      type="text"
                      className="form-input"
                      placeholder="Address"
                      {...register("address", { required: true })}
                    />
                    {errors.address && (
                      <p className="error-message">Address is required</p>
                    )}
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="profile-action-btn-wrapper-usr d-flex justify-content-end">
                    <button
                      className="primary-btn border-0 reset me-3"
                      type="reset"
                      onClick={() => reset()}
                    >
                      Reset
                    </button>
                    <button className="primary-btn border-0" type="submit">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Profile;
